(function($) {

    formHelper.addRule({
        form: '#form-resort-finder',
        status: {
            SUCCESS: function() {

                if (this.data.redirectTo !== '') {

                    this.redirect(this.data.redirectTo);
                }

                this.releaseForm();
            },
            ERROR: function() {

                $('.js-error-message').html(this.errors[0].message);
                $('.js-error-message').show();

                $('.resort-finder').removeClass('loading');
                $('.loader').hide();
                this.releaseForm();
            }
        }
    });
})(jQuery);

// *******************************************************
// FUNCTION:    initResortFinder
// PARAMETERS:  none
// DESCRIPTION: Controls the resort finder tool on the resort directory
// *******************************************************
jQuery(function initResortFinder($) {

    $('.resort-directory').each(function(index, el) {

        var $form = $('#form-resort-finder');

        $('.js-find-resort').each(function() {

            $(this).on("click", function() {

                $('.js-error-message').hide();
                $('.js-error-message').html('');
                $('.resort-finder').addClass('loading');
                $('.loader').show();
                $form.submit();
            });
        });
    });
});